import React, { useState, useEffect } from "react";
import "./RestaurantApprovals.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import ViewDocument from "../components/viewDocument";
import AssignPopup from "../components/AssignPopup";
import RestaurantDetailsModal from "../components/RestaurantDetailsModal";
import { 
  useFilteredApplications,
  useAssignApplication,
  useSelfAssign,
  useTLUsers,
  useApplicationDetails,
  useAllApplications
} from "../../hooks/useApplications";
import { useDataRefresh } from "../../hooks/useDataRefresh";
import {
  useRestaurantsForManagement,
  useUpdateRestaurantOpenStatus,
} from "../../hooks/useRestaurantManagement";
import Menu from "../RestaurantManagement/Menu/Menu";
import OrderPageIntegration from "../RestaurantManagement/Order/OrderPageIntegration";
import { useToast } from "../../mesageToast/ToastContainer";
import api from "../../services/api";
import closeIcon from "../../Assets/close.svg";
import { FaDownload } from "react-icons/fa";

import { SELECTED_RESTAURANT_ID_KEY, SELECTED_RESTAURANT_NAME_KEY } from "../../services/constants";
import axios from "axios";


const RestaurantApprovals = () => {
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [activeSection, setActiveSection] = useState("applications");
  const [activeView, setActiveView] = useState("table");
  const [showAssignDropdown, setShowAssignDropdown] = useState(null);
  const [showHeaderDropdown, setShowHeaderDropdown] = useState(false);
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [selectedRestaurantForAssign, setSelectedRestaurantForAssign] = useState(null);
  const [showRestaurantDetails, setShowRestaurantDetails] = useState(false);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(null);
  const [userDesignation, setUserDesignation] = useState('TL');
  const [viewMode, setViewMode] = useState('edit'); // 'edit' or 'view'
  const [updatingRestaurantId, setUpdatingRestaurantId] = useState(null);
  const addToast = useToast();

  const [selectedQRRestaurant, setSelectedQRRestaurant] = useState(null);
  const [qrImageUrl, setQrImageUrl] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [qrError, setQrError] = useState(null);

  // Fetch QR image blob when a restaurant is selected for QR viewing
  useEffect(() => {
    let active = true;
    let url = null;

    if (!selectedQRRestaurant) {
      setQrImageUrl(null);
      setQrError(null);
      return;
    }

    const fetchQR = async () => {
      setQrLoading(true);
      setQrError(null);
      try {
        const token = localStorage.getItem("token");
        const baseURL = api.defaults.baseURL || "https://api.eatitgo.com/mobo";
        const timestamp = Date.now();
        const response = await axios.get(`${baseURL}/restaurant-management/checkin/qr?t=${timestamp}`, {
          headers: {
            "Authorization": token ? `Bearer ${token}` : "",
            "x-restaurant-id": selectedQRRestaurant._id,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache",
            "Expires": "0",
          },
          responseType: "blob",
        });

        if (!active) return;

        const blob = new Blob([response.data], { type: "image/png" });
        url = URL.createObjectURL(blob);
        setQrImageUrl(url);
      } catch (err) {
        if (!active) return;
        console.error("Error fetching QR Code:", err);
        setQrError("Failed to load QR code. Please try again.");
      } finally {
        if (active) {
          setQrLoading(false);
        }
      }
    };

    fetchQR();

    return () => {
      active = false;
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [selectedQRRestaurant]);

  const handleDownloadQR = () => {
    if (!qrImageUrl || !selectedQRRestaurant) return;

    const link = document.createElement("a");
    link.href = qrImageUrl;
    link.setAttribute("download", `${selectedQRRestaurant.restaurantName || "restaurant"}_QR.png`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  
  // React Query hooks
  const { data: filteredApplications = [], isLoading } = useFilteredApplications(activeSection);
  const { data: allApplications = [], isLoading: isAllAppsLoading } = useAllApplications();
  const { data: tlUsers = [] } = useTLUsers();
  const { data: applicationDetails } = useApplicationDetails(selectedRestaurantId);
  const assignApplicationMutation = useAssignApplication();
  const selfAssignMutation = useSelfAssign();
  const { data: restaurants = [], isLoading: isManagementLoading } =
    useRestaurantsForManagement(activeSection === "orderMenuManagement");
  const updateRestaurantOpenStatus = useUpdateRestaurantOpenStatus();
  
  // Data refresh hook
  const { refreshAllData } = useDataRefresh();
  
  // Get user designation from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserDesignation(userData.designation || 'TL');
      } catch (error) {
        console.error('Error parsing user data:', error);
        setUserDesignation('TL');
      }
    }
  }, []);

  // Function to handle ticket assignment
  const handleAssign = async (restaurantId, userId) => {
    if (userDesignation === 'Manager') {
      assignApplicationMutation.mutate({ applicationId: restaurantId, tlId: userId });
    }
    setShowAssignDropdown(null);
    setShowHeaderDropdown(false);
  };

  const handleAssignClick = (restaurant) => {
    setSelectedRestaurantForAssign(restaurant);
    setShowAssignPopup(true);
  };

  const handlePopupAssign = async (userId, action) => {
    if (userDesignation === 'Manager' && action === 'assign' && selectedRestaurantForAssign && userId) {
      assignApplicationMutation.mutate({ applicationId: selectedRestaurantForAssign._id, tlId: userId });
    } else if (action === 'accept' && selectedRestaurantForAssign) {
      selfAssignMutation.mutate(selectedRestaurantForAssign._id);
    } else if (action === 'reject' && selectedRestaurantForAssign) {
      // Handle reject action if needed
      refreshAllData();
    }
    
    setShowAssignPopup(false);
    setSelectedRestaurantForAssign(null);
  };

  // Function to format date
  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  // Function to determine status display
  const getStatusDisplay = (status) => {
    if (status === true) return { text: "Approved", className: "approved" };
    if (status === false) return { text: "Pending", className: "pending" };
    if (status === "new") return { text: "New", className: "new" };
    if (status === "cancelled") return { text: "Rejected", className: "rejected" };
    return { text: "Approved", className: "new" };
  };

  const handleViewDetails = (restaurant, mode = 'edit') => {
    setSelectedRestaurantId(restaurant._id);
    setViewMode(mode);
    setShowRestaurantDetails(true);
  };

  const openManagementPage = (restaurant, mode) => {
    const restaurantName = restaurant.restaurantName || "Restaurant";
    localStorage.setItem(SELECTED_RESTAURANT_ID_KEY, restaurant._id);
    localStorage.setItem(SELECTED_RESTAURANT_NAME_KEY, restaurantName);
    setActiveView(mode === "menu" ? "menu" : "orders");
  };

  const handleRestaurantStatusToggle = async (restaurant) => {
    const nextIsOpen = !restaurant.isOpen;
    setUpdatingRestaurantId(restaurant._id);

    try {
      await updateRestaurantOpenStatus.mutateAsync({
        restaurantId: restaurant._id,
        isOpen: nextIsOpen,
      });
      addToast(
        nextIsOpen ? "Restaurant Opened" : "Restaurant Closed",
        `${restaurant.restaurantName || "Restaurant"} is now ${nextIsOpen ? "open" : "closed"}.`,
        "success"
      );
    } catch (error) {
      addToast(
        "Status Update Failed",
        error?.response?.data?.message || "Unable to update restaurant status.",
        "error"
      );
    } finally {
      setUpdatingRestaurantId(null);
    }
  };

  useEffect(() => {
    if (applicationDetails && showRestaurantDetails) {
      // Details are automatically fetched by the hook
    }
  }, [applicationDetails, showRestaurantDetails]);
  const getTableHeaders = () => {
    if (activeSection === "applications") {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Location</th>
          <th>Req. Date</th>
          <th>Onboarding Stage</th>
          <th>Current Stage</th>
          <th>Action Type</th>
          <th>Status</th>
          <th>Documents </th>
          <th className="assign-container">          
              <div>View</div>
          </th>
        </tr>
      );
    } else if (activeSection === "requests") {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Location</th>
          <th>Req. Date</th>
          <th>Status</th>
          <th>Documents</th>
          <th>Total Amt.</th>
          <th>Payment</th>
          <th className="assign-container">
            {userDesignation === 'Manager' ? (
              <div onClick={() => setShowHeaderDropdown(!showHeaderDropdown)}>
                Assign
                {showHeaderDropdown && renderAssignDropdown('header')}
              </div>
            ) : (
              <div>Assign</div>
            )}
          </th>
        </tr>
      );
    } else if (activeSection === "myTickets") {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Location</th>
          <th>Req. Date</th>
          <th>Status</th>
          <th>Documents</th>
          <th>Total Amt.</th>
          <th>Payment</th>
          <th>Actions</th>
        </tr>
      );
    } else {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Status</th>
        </tr>
      );
    }
  };

  const renderAssignDropdown = (restaurantId) => (
    <div className="assign-dropdown">
      {tlUsers.map((user) => (
        <div
          key={user._id}
          className="assign-option"
          onClick={() => handleAssign(restaurantId, user._id)}
        >
          {user.name}
        </div>
      ))}
    </div>
  );

  return (
    <div className="dashboard-container">
      <div className="content">
        <h1 className="dashboard-title">Restaurants-approvals</h1>
        <div className="sts">
          <div
            className={`status-card ${activeSection === "applications" ? "active" : ""}`}
            onClick={() => setActiveSection("applications")}
            style={activeSection === "applications" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "applications" ? { color: "white" } : {}}>Applications</span>
          </div>
          <div
            className={`status-card ${activeSection === "requests" ? "active" : ""}`}
            onClick={() => setActiveSection("requests")}
            style={activeSection === "requests" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "requests" ? { color: "white" } : {}}>Requests</span>
          </div>
          <div
            className={`status-card ${activeSection === "myTickets" ? "active" : ""}`}
            onClick={() => setActiveSection("myTickets")}
            style={activeSection === "myTickets" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "myTickets" ? { color: "white" } : {}}>My Tickets</span>
          </div>
          <div
            className={`status-card ${activeSection === "approved" ? "active" : ""}`}
            onClick={() => setActiveSection("approved")}
            style={activeSection === "approved" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "approved" ? { color: "white" } : {}}>Approved</span>
          </div>
          <div
            className={`status-card ${activeSection === "rejected" ? "active" : ""}`}
            onClick={() => setActiveSection("rejected")}
            style={activeSection === "rejected" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "rejected" ? { color: "white" } : {}}>Rejected</span>
          </div>
          <div
            className={`status-card ${activeSection === "orderMenuManagement" ? "active" : ""}`}
            onClick={() => {
              setActiveSection("orderMenuManagement");
              setActiveView("table");
            }}
            style={activeSection === "orderMenuManagement" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "orderMenuManagement" ? { color: "white" } : {}}>Order &amp; Menu Management</span>
          </div>
        </div>

        {activeSection === "orderMenuManagement" && activeView === "menu" ? (
          <Menu onBack={() => setActiveView("table")} />
        ) : activeSection === "orderMenuManagement" && activeView === "orders" ? (
          <OrderPageIntegration onBack={() => setActiveView("table")} />
        ) : activeSection === "orderMenuManagement" ? (
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Restaurant Name</th>
                <th>City</th>
                <th>Phone</th>
                {/* <th>Menu Management</th> */}
                 <th>Order Management</th>
                 <th>Status</th>
                 <th>QR Code</th>
              </tr>
            </thead>
            <tbody>
              {isManagementLoading ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    Loading...
                  </td>
                </tr>
              ) : restaurants.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    No restaurants available for management
                  </td>
                </tr>
              ) : (
                restaurants.map((restaurant) => (
                  <tr key={restaurant._id}>
                    <td>{restaurant.restaurantName || "N/A"}</td>
                    <td>{restaurant.city || "N/A"}</td>
                    <td>{restaurant.restaurantPhoneNumber || "N/A"}</td>
                    {/* <td>
                      <button
                        className="view-btn"
                        onClick={() => openManagementPage(restaurant, "menu")}>
                        Menu Management
                      </button>
                    </td> */}
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => openManagementPage(restaurant, "orders")}>
                        Order Management
                      </button>
                    </td>
                    <td>
                      <div className="restaurant-status-control">
                        <span className={`restaurant-status-text ${restaurant.isOpen ? "open" : "closed"}`}>
                          {restaurant.isOpen ? "Open" : "Close"}
                        </span>
                        <label className="bo-status-switch">
                          <input
                            type="checkbox"
                            checked={Boolean(restaurant.isOpen)}
                            disabled={updatingRestaurantId === restaurant._id}
                            onChange={() => handleRestaurantStatusToggle(restaurant)}
                          />
                          <span className="bo-status-slider"></span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <button
                        className="view-btn qr-btn"
                        onClick={() => setSelectedQRRestaurant(restaurant)}>
                        View QR
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        ) : (
          <table className="dashboard-table">
            <thead>
              {getTableHeaders()}
            </thead>
            <tbody>
              {activeSection === "applications" ? (
                isAllAppsLoading ? (
                  <tr>
                    <td colSpan="9" style={{textAlign: 'center', padding: '20px'}}>Loading...</td>
                  </tr>
                ) : allApplications.length === 0 ? (
                  <tr>
                    <td colSpan="9" style={{textAlign: 'center', padding: '20px'}}>No applications found</td>
                  </tr>
                ) : (
                  allApplications.map((restaurant) => (
                    <tr key={restaurant._id}>
                      <td>#{restaurant.caseNumber || 'ROB-' + new Date().getFullYear() + (new Date().getMonth() + 1).toString().padStart(2, '0') + new Date().getDate().toString().padStart(2, '0')}</td>
                      <td>{restaurant.restaurantId?.restaurantName || 'N/A'}</td>
                      <td>{restaurant.restaurantId?.restaurantAddress?.city || 'N/A'}</td>
                      <td>{formatDate(restaurant.createdAt || new Date())}</td>
                      <td>{restaurant.onboardingStage || 'N/A'}</td>
                      <td>{restaurant.currentStage || 'N/A'}</td>
                      <td>{restaurant.actionType || 'N/A'}</td>
                      <td>
                        <span className={`status ${restaurant.status === 'PENDING' ? 'pending' : restaurant.status === 'APPROVED' ? 'approved' : 'rejected'}`}>
                          {restaurant.status || 'N/A'}
                        </span>
                      </td>
                      <td>{(restaurant.restaurantId?.menuDetails?.length || 0) + (restaurant.documentCount || 0)}</td>
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => handleViewDetails(restaurant, 'view')}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                )
              ) : filteredApplications && filteredApplications.length > 0 ? (
                filteredApplications.map((restaurant) => {
              // const moStatus = restaurant.moStatus || "Pending";
              // const boStatus = restaurant.boStatus || "Pending";
              
              if (activeSection === "requests") {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || 'ROB-' + new Date().getFullYear() + (new Date().getMonth() + 1).toString().padStart(2, '0') + new Date().getDate().toString().padStart(2, '0')}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.name || 'N/A'}</td>
                    <td>{restaurant.restaurantId?.restaurantAddress?.city || restaurant.location || 'N/A'}</td>
                    <td>{formatDate(restaurant.createdAt || new Date())}</td>
                    <td>
                      <span className="status pending">
                        TL Review
                      </span>
                    </td>
                    <td>{restaurant.restaurantId?.menuDetails?.length || 0}</td>
                    <td>{restaurant.restaurantId?.totalAmount || 0}</td>
                    <td>{restaurant.paymentStatus || 'Pending'}</td>
                    <td>
                      {userDesignation === 'Manager' ? (
                        <button
                          className="assign-btn"
                          onClick={() => handleAssignClick(restaurant)}
                        >
                          Assign
                        </button>
                      ) : (
                        <button
                          className="assign-btn"
                          onClick={() => handleAssignClick(restaurant)}
                        >
                          Self Assign
                        </button>
                      )}
                    </td>
                  </tr>
                );
              } else if (activeSection === "myTickets") {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || restaurant._id}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.name || 'N/A'}</td>
                    <td>{restaurant.restaurantId?.restaurantAddress?.city || restaurant.location || 'N/A'}</td>
                    <td>{formatDate(restaurant.createdAt || new Date())}</td>
                    <td>
                      <span className="status pending">
                        Pending Verification
                      </span>
                    </td>
                    <td>{restaurant.restaurantId?.menuDetails?.length || 0}</td>
                    <td>{restaurant.restaurantId?.totalAmount || 0}</td>
                    <td>{restaurant.paymentStatus || 'Pending'}</td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => {
                          handleViewDetails(restaurant);
                        }}>
                        View
                      </button>
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || 'ROB-' + new Date().getFullYear() + (new Date().getMonth() + 1).toString().padStart(2, '0') + new Date().getDate().toString().padStart(2, '0')}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.name || "N/A"}</td>
                    <td>
                      <span className={`status ${getStatusDisplay(restaurant.boStatus || restaurant.moStatus).className}`}>
                        {getStatusDisplay(restaurant.boStatus || restaurant.moStatus).text}
                      </span>
                    </td>
                  </tr>
                );
              }
            })
              ) : (
                <tr>
                  <td colSpan={activeSection === "applications" ? "9" : activeSection === "myTickets" ? "9" : activeSection === "requests" ? "9" : "3"} style={{textAlign: 'center', padding: '20px'}}>
                    {isLoading ? 'Loading...' : 'No applications found'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
        {selectedRestaurant && (
          <ViewDocument
            restaurant={selectedRestaurant}
            documents={selectedDocs}
            onClose={() => setSelectedRestaurant(null)}
          />
        )}
        
        <AssignPopup
          isOpen={showAssignPopup}
          onClose={() => setShowAssignPopup(false)}
          onAssign={handlePopupAssign}
          tlUsers={userDesignation === 'Manager' ? tlUsers : []}
          userDesignation={userDesignation}
        />
        
        <RestaurantDetailsModal
          open={showRestaurantDetails}
          onClose={() => {
            setShowRestaurantDetails(false);
            setSelectedRestaurantId(null);
            setViewMode('edit');
          }}
          data={applicationDetails}
          viewMode={viewMode}
        />

        {selectedQRRestaurant && (
          <div className="qr-modal-overlay">
            <div className="qr-modal">
              <div className="qr-modal-header">
                <h3 className="qr-modal-title">
                  {selectedQRRestaurant.restaurantName} QR Code
                </h3>
                <button
                  className="qr-modal-close-btn"
                  onClick={() => setSelectedQRRestaurant(null)}>
                  <img src={closeIcon} alt="Close" />
                </button>
              </div>

              <div className="qr-content">
                {qrLoading ? (
                  <div className="qr-loading-text">Loading QR Code...</div>
                ) : qrError ? (
                  <div className="qr-error-text">{qrError}</div>
                ) : qrImageUrl ? (
                  <div className="qr-image-wrapper">
                    <img
                      src={qrImageUrl}
                      alt={`${selectedQRRestaurant.restaurantName} QR Code`}
                      className="qr-code-img"
                    />
                  </div>
                ) : null}
              </div>

              <div className="qr-modal-actions">
                <button
                  className="qr-cancel-btn"
                  onClick={() => setSelectedQRRestaurant(null)}>
                  Cancel
                </button>
                <button
                  className="qr-download-btn"
                  onClick={handleDownloadQR}
                  disabled={!qrImageUrl || qrLoading}>
                  <FaDownload style={{ marginRight: '6px' }} /> Download
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RestaurantApprovals;
